import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Cancel';
import axios from "axios";
import moment from "moment";
import "./ErrorBoundary.scss";

class ErrorBoundary extends Component {

  state = {
    error: '',
    errorInfo: '',
    hasError: false,
    apiResponse: null,
    application: null
  };

  constructor(props) {
    super(props);
  }

  static getDerivedStateFromError(error) {
    return {hasError: true, error};
  }

  componentDidCatch(error, errorInfo) {
    const self = this;
    this.setState({errorInfo, error});

	  const applicationID = this.props.application?.applicationId
		const applicationNo = this.props.application?.applicationNo
		
		
    const data = {
      url: window.location.href,
      errorMessage: error ? error.message : "",
      errorInfo: JSON.stringify({ applicationid: applicationID, applicaitonno: applicationNo, error: errorInfo ? errorInfo.componentStack.toString() : "NA" })
    }
  }

  render() {
    const {hasError, errorInfo, error, apiResponse} = this.state;
    
    if (hasError) {
      return (
        <div class="apiErrorInfo">
          <h2><CloseIcon className="icon"/> Sorry, we were unable to process your request</h2>
          <p>We apologise for any inconvenience caused. Our team is working to resolve this as quickly as possible.</p>
          <p>Please try again later. If this error persists, please contact the agency listed below.</p>
          {apiResponse && (<>
            <p><strong>Reference:</strong><br/>{apiResponse.traceId}</p>
            <p><strong>Date & time:</strong><br/>{moment(apiResponse.timestamp).format("DD/MM/YYYY hh:mm:ss a")}</p>
          </>)}
          {this.props.application?.applicationNo && (
            <p><strong>Application Number:</strong><br/>{this.props.application?.applicationNo}</p>
          )}
        </div>

      );
    } else {
      // next code block goes here
      return this.props.children;
    }
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const {application} = state;
  return {
    ...ownProps,
    application
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);